import { createSlice } from '@reduxjs/toolkit';
import axios from '../utils/interceptor';
import { getItem } from '../utils/storage';
import { setUser } from './appSlice';

const initialState = {
  userInfo: undefined,
  isAdpAssociate: false,
  referringSource: '',
  isLoading: false,
  appstore: 'US'
};

const slice = createSlice({
  name: 'userContext',
  initialState,
  reducers: {
    setUserContextLoading(state, action) {
      state.isLoading = action.payload;
    },
    setUserContext(state, action) {
      state.userInfo = action.payload;
      const { userAppStoreProfiles: { productChannelCodes = [], businessTypeCodes = [] } = {} } = action.payload || {};
      state.isAdpAssociate = productChannelCodes.includes('ADP') && businessTypeCodes.includes('ADP');
      state.persona = state.isAdpAssociate ? 'sales' : 'client';
    },

    setReferringSource(state, action) {
      state.referringSource = action.payload;
    }
  }
});

export const reducer = slice.reducer;
export const { setUserContextLoading, setReferringSource, setUserContext } = slice.actions;

export const getUserContext = () => async (dispatch, getState) => {
  // console.log(`🔄 Fetching user context ${JSON.stringify(getState(), 2, null)}`);
  const state = getState();
  const userContextState = state.userContext || {};
  const { isLoading } = userContextState;
  if (isLoading) return;
  const queryString = new URLSearchParams();
  queryString.set('mask', true);
  try {
    dispatch(setUserContextLoading(true));
    await axios
      .request({
        method: 'GET',
        url: `/api/user-context?${queryString}`
      })
      .then((response) => {
        response.data.appDirectInfo = response.data.appDirectInfo || {};
        response.data.appDirectInfo.company = response.data.appDirectInfo.company || {};
        response.data.appDirectInfo.user = response.data.appDirectInfo.user || {};
        response.data.appDirectInfo.user.contact = response.data.appDirectInfo.user.contact || {};
        response.data.appDirectInfo.user.contact.address = response.data.appDirectInfo.user.contact.address || {};
        const expires_at = getItem('expires_at');
        const adpWebID = response.data?.adpWebID || '';
        const webIDCookieExists = document.cookie.match(/^(.*;)?\s*adp_web_id\s*=\s*[^;]+(.*)?$/);
        if (!webIDCookieExists) document.cookie = `adp_web_id=${adpWebID}; Max-Age=${expires_at}; domain=.adp.com; SameSite=None; Secure`;
        dispatch(setUserContext(response.data));
        // also keep the global app user in sync
        dispatch(setUser(response.data?.appDirectInfo?.user || null));
      });
  } catch (e) {
    console.log(e.message);
    dispatch(setUserContext());
    dispatch(setUser(null));
  } finally {
    dispatch(setUserContextLoading(false));
  }
};
